<nav id="menu1" [class]="menu1Class" class="nav nav-visible" *ngIf="!itsMobile">
    <ul>
        <span id="menu1Bar" [class]="menu1BarClass" class="bar"></span>
        <li id="menu1Item1" class="btn-v" (click)="menuClick('menu1', 'menu1Item1')">Contactless</li>
        <li id="menu1Item2" class="btn-v" (click)="menuClick('menu1', 'menu1Item2')">Global currency</li>
        <li id="menu1Item3" class="btn-v" (click)="menuClick('menu1', 'menu1Item3')">e-Commerce</li>
        <li id="menu1Item4" class="btn-v" (click)="menuClick('menu1', 'menu1Item4')">Split Payment</li>
        <li id="menu1Item5" class="btn-v" (click)="menuClick('menu1', 'menu1Item5')">Switch to miles</li>
        <li id="menu1Item6" class="btn-v" (click)="menuClick('menu1', 'menu1Item6')">Easy Activation</li>
        <li id="menu1Item7" class="btn-v" (click)="menuClick('menu1', 'menu1Item7')">My Preferences</li>
        <li id="menu1Item8" class="btn-v" (click)="menuClick('menu1', 'menu1Item8')">Unique Travel <br> Content</li>
        <li id="menu1Item9" class="btn-v" (click)="menuClick('menu1', 'menu1Item9')">Conversational <br> banking</li>
    </ul>
</nav>
<div [class]="videoClass" class="video-fixed video-visible" *ngIf="!itsMobile">
    <div class="phone">
        <div class="content">
            <video loop autoplay muted playsinline [src]="videoSrc" onloadedmetadata="this.muted = true">
            </video>
        </div>
    </div>
    <div class="info-visa">
        <p>©2023 Visa. All rights reserved.</p>
        <img src="./assets/img/gennius/visa/logo-visaw.png" alt="gennius" class="gennius__img gennius__img--reserved">
    </div>
</div>
<section class="snap">
    <section class="section" id="item-33-section">
        <section class="intro">
            <div class="container">
                <div class="right">
                    <div class="item" id="item-33">
                        <img class="gennius__img visapartner" src="./assets/img/gennius/visa/logo-visapartner.png"
                            alt="gennius">
                        <span>Proud members of the Visa Fintech Partner Connect</span>
                        <p><strong>Connecting Visa’s clients with Visa Fintech Partner Connect partners:</strong> Visa believes in the power of
                            technology and innovation to improve cardholder digital experiences and open up new value for Visa
                            cardholders and clients around the globe.</p>
                        <div class="download">
                            <a class="btn-v btn-gennius" href="https://partner.visa.com/site/partner-directory/novae.html" target="_blank">Learn more</a>
                            <a class="btn-download" href="./assets/docs/VCA-Novae-Product-Launch-Research-Full-Report-04192022.pdf" target="_blank">
                                <img class="gennius__img download" src="./assets/img/gennius/visa/icon-download.png"
                                    alt="gennius">
                                <p>Download Visa VCA Report</p>
                            </a>
                        </div>
                    </div>
                    <div class="item item2">
                        <img class="gennius__img rewards" src="./assets/img/gennius/visa/logo-rewards-w.png" alt="gennius">
                        <span>Visa Latin America & Caribbean</span>
                        <img class="gennius__img every" src="./assets/img/gennius/visa/logo-visa-every.png" alt="gennius">
                        <p><strong>Built in partnership with Visa to deliver smart payments & loyalty solutions in Latin America and the
                            Caribbean.</strong>
                            An all-in-one value proposition for Visa's most demanding customers.</p>
                        <div class="download">
                            <a class="btn-v btn-gennius" id="btn-a">Learn more</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>
    <section class="scrolling" id="item-a">
        <mat-expansion-panel hideToggle class="tab-visa" id="test">
            <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="container">
                    <div class="text">
                        <p>Important Notes</p>
                        <img class="gennius__img gennius__img--intro" src="./assets/img/gennius/visa/arrow.png" alt="gennius">
                    </div>
                </div>
            </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="content-tab">
                <span>Important Notes</span>
                <p>Confidentiality: This presentation is furnished to you solely in your capacity as a client of Visa or as a participant in the Visa payments system. By attending or viewing this presentation, you acknowledge that the information contained herein (the “Information”) is confidential and subject to confidentiality restrictions contained in Visa’s operating regulations or other confidentiality agreements that limit your use of the Information. You agree to keep the Information confidential and not to use the Information for any purpose other than in your capacity as a customer of Visa or as a participant in the Visa payments system. The Information may only be disseminated within your organization on a need-to-know basis to enable your participation in the Visa payments system. Please be advised that the Information may constitute material non-public information under U.S. federal securities laws, and that buying or selling securities of Visa Inc. while being aware of material non-public information constitutes a violation of applicable U.S. federal securities laws.
                </p>
                <p>All brand names, logos and/or trademarks are the property of their respective owners, are used for identification purposes only, and do not necessarily imply product endorsement or affiliation with Visa.
                </p>
                <p>Product/Ideas in Development: This document is intended for illustrative purposes only. It contains depictions of a product currently in the process of development or deployment, and should be understood as a representation of the potential features of the fully-deployed product. The final version of this product may or may not contain all of the features described in this presentation.
                </p>
                <p>Forward-looking statements: This presentation contains forward-looking statements within the meaning of the U.S. Private Securities Litigation Reform Act of 1995 that may relate to, among other things, our future operations, prospects, developments, strategies and business growth. Forward-looking statements generally are identified by words such as “believes,” “estimates,” “expects,” “intends,” “may,” “projects,” “could,” “should,” “will,” “continue,” and other similar expressions. All statements other than statements of historical fact could be forward-looking statements, which speak only as of the date they are made, are not guarantees of future performance, and are subject to certain risks, uncertainties and other factors, many of which are beyond our control and are difficult to predict. We describe risks and uncertainties that could cause actual results to differ materially from those expressed in, or implied by, any of these forward-looking statements in our filings with the SEC. Except as required by law, we do not intend to update or revise any forward-looking statements as a result of any new information, future events or otherwise.
                </p>
                <p>Limitation of Liability
                    The program information is provided for informational purposes only and should not be relied upon for marketing, legal, regulatory or other advice.  Any programs should be independently evaluated in light of your specific business needs and any applicable laws and regulations. Much of the information presented here applies internationally, but some information may apply only to certain countries or regions. You should check the applicability of any information contained herein to you or your organization in your jurisdiction.  You should also consult with legal counsel regarding any new program or change in existing program where appropriate. The information, recommendations, or “best practices” contained herein are provided "AS IS”. Visa is not responsible for your use of these materials, program information, best practice recommendations, or other information, including errors of any kind, contained in this document. Visa makes no warranty, express or implied, and explicitly disclaims the warranties of merchantability and fitness for a particular purpose. To the extent permitted by applicable law, Visa shall not be liable to a client or any third party for any damages under any theory of law, including, without limitation, any special, consequential, incidental, or punitive damages, nor any damages for loss of business profits, business interruption, loss of business information, or other monetary loss, even if advised of the possibility of such damages.</p>
                    <div class="reserved">
                        <p>©2023 Visa. All rights reserved.</p>
                        <img class="gennius__img gennius__img--reserved" src="./assets/img/gennius/visa/logo-visa.png" alt="gennius">
                    </div>
            </div>
        </mat-expansion-panel>
        <section class="gennius--intro section-Htwo white" id="item-34-section">
            <div class="container">
                <div class="gennius__center">
                    <h4 id="item-34" >Introducing</h4>
                    <img class="gennius__img gennius__img--intro" src="./assets/img/gennius/visa/logo-rewards.png" alt="gennius">
                    <div class="line"></div>
                    <img class="gennius__img ever" src="./assets/img/gennius/visa/logo-visa-ever.png" alt="gennius">
                    <span class="subtittle">Our digital capability framework brings added value to fintech, insurtech and loyalty brands.</span>
                </div>
                <div class="image">
                    <div id="scene" class="container-image">
                        <img class="main-image" src="./assets/img/gennius/visa/img-global.webp" alt="">
                    </div>
                    <div class="item two">
                        <img src="./assets/img/gennius/visa/icon-i-assurance-b1.png" alt="">
                        <p>Assurance <br>on the go</p>
                    </div>
                    <div class="item three">
                        <img src="./assets/img/gennius/visa/icon-i-marketplace-b1.png" alt="">
                        <p>Marketplace <br> of products <br> and services</p>
                    </div>
                    <div class="item four">
                        <img src="./assets/img/gennius/visa/icon-i-messanging-b1.png" alt="">
                        <p>Messaging <br>Services</p>
                    </div>
                    <div class="item five">
                        <img src="./assets/img/gennius/visa/icon-i-ai-b1.png" alt="">
                        <p>Powered <br> by AI</p>
                    </div>
                    <div class="item six">
                        <img src="./assets/img/gennius/visa/icon-i-split-b1.png" alt="">
                        <p>Split <br> Payment</p>
                    </div>
                    <div class="item seven">
                        <p>Multi source<br>
                        pre - post<br>
                        transactions</p>
                        <img src="./assets/img/gennius/visa/icon-i-multi-source-b1.png" alt="">
                    </div>
                    <div class="item eight">
                        <img src="./assets/img/gennius/visa/icon-i-digital-b1.png" alt="">
                        <p>Digital <br> currency</p>
                    </div>
                    <div class="item ten">
                        <img src="./assets/img/gennius/visa/icon-i-wallet-b1.png" alt="">
                        <p>Wallets<br>
                        of wallets</p>
                    </div>
                    <div class="item eleven">
                        <img src="./assets/img/gennius/visa/icon-i-push-b1.png" alt="">
                        <p>Push<br>
                        Payments</p>
                    </div>
                    <div class="item twelve">
                        <img src="./assets/img/gennius/visa/icon-i-instant-b1.png" alt="">
                        <p>Instant<br>
                        Issuance</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="gennius--evolution gennius--container white" id="item-35-section">
            <div class="container gennius">
                <div class="gennius__bloque gennius__bloque--evolution">
                    <div class="gennius__left gennius__left--evolution">
                        <img class="gennius__img gennius__img--rewardsW" src="./assets/img/gennius/visa/logo-rewards-w.png" alt="gennius">
                        <span id="item-35">The latest evolution of digital payments
                            and loyalty.</span>
                        <img class="gennius__img gennius__img--iphone" src="./assets/img/gennius/visa/evolution-iphone.webp" alt="gennius">
                    </div>
                    <div class="gennius__right gennius__right--evolution">
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-1.png" alt="gennius">
                            </div>
                            <p><strong>Universal redemption</strong> online or in store in <strong>100 million<span class="num">1</span></strong> <strong>merchants worldwide</strong> through the most <strong>revolutionary payments methods</strong>.</p>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-2.png" alt="gennius">
                            </div>
                            <p><strong>Interactive customer support</strong>: Smart support through user’s favorites channels: iMessage, WhatsApp, Facebook Messenger and Instagram. </p>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-3.png" alt="gennius">
                            </div>
                            <p><strong>Travel and entertainment redemptions</strong> selection with ease to select routes, pricing, and more.</p>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-4.png" alt="gennius">
                            </div>
                            <p><strong>Global currency:</strong> Use your miles through major wallets even contactless.</p>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-5.png" alt="gennius">
                            </div>
                            <p>A digital, <strong>white-label and agnostic</strong> solution.</p>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-6.png" alt="gennius">
                            </div>
                            <p><strong>Single-tenant</strong> solution that can be <strong>fully customized</strong>.</p>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-7.png" alt="gennius">
                            </div>
                            <p>Embraced by <strong>all segments</strong> across social groups and <strong>along the world</strong>.</p>
                            <span class="especial">Source:  1) Visa - Fact Sheet 2020.</span>
                        </div>
                        <div class="gennius__item gennius__item--evolution">
                            <div class="imgs">
                                <img class="gennius__img gennius__img--evolution" src="./assets/img/gennius/visa/evolution-icon-8.png" alt="gennius">
                            </div>
                            <p><strong>Miles management</strong>: Control over rewards balance through best-in-class UX/UI.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </section>
    <section class="section gennius--universal white" id="item-36-section">
        <div class="container gennius">
            <div class="gennius__center">
                <h4 id="item-36"><strong>My Rewards</strong><br> Universal redemption:<br> everyday spend</h4>
            </div>
        </div>
        <div class="gennius__bloque gennius__bloque--universal">
            <img class="gennius__img gennius__img--universal" src="./assets/img/gennius/visa/universal-phone.webp" alt="gennius">
            <div class="container gennius container-absolute">
                <div class="gennius__right gennius__right--universal">
                    <span>Use your miles anywhere, online or in store, globally or locally, at 100 million merchants worldwide, with exclusive benefits. All transactions are completed with the standard Visa security.</span>
                </div>
            </div>
        </div>
        <div class="container gennius">
            <div class="gennius__logos">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-amazon.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-netflix.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-uber.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-directv.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-apple.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-ebay.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-wallmart.svg" alt="gennius">
                <img class="gennius__img gennius__img--universal-logo" src="./assets/img/gennius/visa/logo-macdonalds.svg" alt="gennius">
            </div>
        </div>
    </section>
    <section id="item37-section" class="section gennius--omnichannel white">
        <div class="container gennius">
            <div class="gennius__center">
                <h4 id="item-37">Omnichannel accessibility</h4>
            </div>
            <div class="gennius__bloque--item">
                <div class="gennius__item gennius__item--omnichannel">
                    <img class="gennius__img gennius__img--omnichannel" src="./assets/img/gennius/visa/omnichannel-icon-1.png" alt="gennius">
                    <span>Ability to <strong>redeem points</strong> anytime, anywhere</span>
                </div>
                <div class="gennius__item gennius__item--omnichannel">
                    <img class="gennius__img gennius__img--omnichannel" src="./assets/img/gennius/visa/omnichannel-icon-2.png" alt="gennius">
                    <span><strong>Interactive support</strong> through WhatsApp, iMessage, Facebook MSN, Instagram </span>
                </div>
                <div class="gennius__item gennius__item--omnichannel">
                    <img class="gennius__img gennius__img--omnichannel" src="./assets/img/gennius/visa/omnichannel-icon-3.png" alt="gennius">
                    <span>Ability to switch between <strong>personal devices</strong></span>
                </div>
                <div class="gennius__item gennius__item--omnichannel">
                    <img class="gennius__img gennius__img--omnichannel" src="./assets/img/gennius/visa/omnichannel-icon-4.png" alt="gennius">
                    <span>Ability to choose from <strong>countless redemption opportunities</strong></span>
                </div>
            </div>
            <img class="gennius__img gennius__img--omnichannel-phone" src="./assets/img/gennius/visa/omnichannel-phone.png" alt="gennius">
            <span class="text">More freedom for better engagement</span>
        </div>
    </section>
    <section class="section gennius--intro gennius--capabilities white"id="item38-section">
        <div class="container">
            <div class="gennius__center">
                <h4 id="item-38" class="target0">Capabilities</h4>
                <img class="gennius__img gennius__img--intro" src="./assets/img/gennius/visa/logo-rewards.png" alt="gennius">
                <div class="line"></div>
                <img class="gennius__img ever" src="./assets/img/gennius/visa/logo-visa-ever.png" alt="gennius">
                <span class="subtittle">Redeem miles upon checkout anywhere, anytime, and instantly turn miles into cash.</span>
            </div>
        </div>
    </section>
    <section class="main" id="item-c">
        <div class="bg-wrap">
            <div class="bg"></div>
            <app-connect></app-connect>
        </div>
        <section id="item-39-section" class="section parallax1">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target1">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/contactless-img.webp" alt="gennius">
                                <h4 class="target1">Contactless</h4>
                                <p>Redeem miles in store with the <br> <strong>My Rewards</strong> app’s contactless <br> feature. </p>
                            </div>
                            <div id="item-39" class="gennius__right gennius__right--loyalty" >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-39-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-40-section" class="section parallax2">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target2">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/global-img.webp" alt="gennius">
                                <h4 class="target2">Global <br> Currency</h4>
                                <p>Redeem your miles via mobile, <br> wearables, through the app and <br> all major e-wallets.</p>
                                <img class="logos-pay"  src="./assets/img/gennius/visa/logos-pay.webp" alt="gennius">
                            </div>
                            <div id="item-40" class="gennius__right gennius__right--loyalty" >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-40-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-41-section" class="section parallax3">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target3">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/commerce-img.webp" alt="gennius">
                                <h4 class="target3">e-Commerce</h4>
                                <p>Redeem your miles on your <br> preferred e-Commerce sites. <br> Simply add your card to your <br> e-wallet upon checkout.</p>
                                <img class="logos-shop"  src="./assets/img/gennius/visa/logos-shop.webp" alt="gennius">
                            </div>
                            <div id="item-41" class="gennius__right gennius__right--loyalty" >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-41-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-42-section" class="section parallax4">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target4">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/split-img.webp" alt="gennius">
                                <h4 class="target4">Split Payment</h4>
                                <p>Combine rewards with your <br> preferred cards. No need to wait <br> until you earn miles to get <br> rewarded.</p>
                            </div>
                            <div id="item-42" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-42-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-43-section" class="section parallax5">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target5">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/switch-img.webp" alt="gennius">
                                <h4 class="target5">Switch to miles</h4>
                                <p>Apply miles to your purchases, <br> either fully or partially. Get the <br> freedom and flexibility to best fit <br> your needs.</p>
                            </div>
                            <div id="item-43" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-43-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-44-section" class="section parallax6">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target6">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/easy-img.webp" alt="gennius">
                                <h4 class="target6">Easy Activation</h4>
                                <p>Sign up quickly, easily and <br> securely. Download the app & <br> sign up to get activated in few <br> steps, and you're all set!</p>
                            </div>
                            <div id="item-44" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-44-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-45-section" class="section parallax7">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target7">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/preferences-img.webp" alt="gennius">
                                <h4 class="target7">My Preferences</h4>
                                <p>Edit your preferences, complete <br> your profile, choose your cards of <br> preference. As easy as it sounds.</p>
                            </div>
                            <div id="item-45" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-45-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-46-section" class="section parallax8">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target8">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <div class="text-image">
                                    <img class="icon-image"  src="./assets/img/gennius/visa/unique-img.webp" alt="gennius">
                                    <h4 class="target8">Unique <br> Travel <br> Content</h4>
                                </div>
                                <p>Millions of travel options around the <br> world at unrivaled Expedia deals.</p>
                                <div class="block-expedia">
                                    <img src="./assets/img/gennius/visa/logo-expedia.svg" alt="">
                                </div>
                                <div class="row">
                                    <div class="column">
                                        <img src="./assets/img/gennius/visa/icon-plane.svg" alt="gennius">
                                        <h3>70K+</h3>
                                        <p>Daily flights to <br> 1.7K+ destinations</p>
                                    </div>
                                    <div class="column">
                                        <img src="./assets/img/gennius/visa/icon-hotel.svg" alt="gennius">
                                        <h3>400K</h3>
                                        <p>Hotels in 25K+ <br> cities worldwide</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="column">
                                        <img src="./assets/img/gennius/visa/icon-ticket.svg" alt="gennius">
                                        <h3>29K+</h3>
                                        <p>Tours, shows, <br> activities, and <br> attraction</p>
                                    </div>
                                    <div class="column">
                                        <img src="./assets/img/gennius/visa/icon-rental.svg" alt="gennius">
                                        <h3>2MM+</h3>
                                        <p>Car rental <br> companies in <br> 200 countries </p>
                                    </div>
                                    <div class="column column--last">
                                        <img src="./assets/img/gennius/visa/icon-vacation.svg" alt="gennius">
                                        <h3>190<span>countries</span></h3>
                                        <p>Vacation <br> homes in <br> 190 countries</p>
                                    </div>
                                </div>
                            </div>
                            <div id="item-46" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-46-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-47-section" class="section parallax8">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <div class="text-image">
                                    <img class="icon-image"  src="./assets/img/gennius/visa/unique-img.webp" alt="gennius">
                                    <h4 class="target9">Unique <br> Travel <br> Content</h4>
                                </div>
                                <p>Millions of travel options around the <br> world at unrivaled Expedia deals.</p>
                                <p class="blue">When travelling</p>
                                <ul>
                                    <li><strong>Best-Price Guarantee.</strong></li>
                                    <li><strong>Branded Rules: My Rewards </strong> proprietary <br> benefits allow cardholders to enjoy at no extra <br> cost:</li>
                                    <li><strong>No rebooking fees: </strong> when rescheduling a <br> reservation.</li>
                                    <li>
                                        <p><strong>Flights</strong></p>
                                        <ul>
                                            <li>No fees or penalties due to trip <br> cancellation / lost & delayed luggage</li>
                                            <li>No seat restrictions</li>
                                            <li>No blackout dates</li>
                                        </ul>
                                    </li>
                                    <li> <p><strong>Hotels</strong></p>  Covers medical expenses in case of <br> emergency / trip interruption</li>
                                </ul>
                            </div>
                            <div id="item-47" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-47-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-48-section" class="section parallax10">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target9">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <img class="icon-image"  src="./assets/img/gennius/visa/contactless-img.webp" alt="gennius">
                                <h4 class="target10">Conversational <br> banking</h4>
                                <p class="blue">Meet <span>alle</span>, our always-on, <br> always-ready hum/bot</p>
                                <p>Chat with our proprietary <strong>smart <br> support</strong> in the app or through <br> <strong>iMessage, WhatsApp, Instagram <br> and Facebook Messenger.</strong> </p>
                                <img class="logos-networks"  src="./assets/img/gennius/visa/logos-networks.webp" alt="gennius">
                            </div>
                            <div id="item-48" class="gennius__right gennius__right--loyalty"  >
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video id="item-48-video" autoplay loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>

                                    </div>
                                </div>
                                <div class="info-visa info-visa--last">
                                    <p>©2023 Visa. All rights reserved.</p>
                                    <img src="./assets/img/gennius/visa/logo-visaw.png" alt="gennius" class="gennius__img gennius__img--reserved">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>
    <section class="scrolling">
        <section class="gennius--intro gennius--novae white">
            <div class="gennius__center">
                <h4 id="item-49">Visa & novae</h4>
                <img class="gennius__img gennius__img--intro" src="./assets/img/gennius/visa/logo-rewards.png" alt="gennius">
                <div class="line"></div>
                <img class="gennius__img ever" src="./assets/img/gennius/visa/logo-visa-ever.png" alt="gennius">
                <h4 class="subtittle">My Rewards for banks without a Loyalty Program</h4>
            </div>
            <div class="gennius__bloque gennius__bloque--novae gennius__bloque--top">
                <div class="gennius__column gennius__column--novae">
                    <span>Why</span>
                    <p>Helps to boost cardholders’ commitment to the issuer, which may translate into greater card usage, spending, and retention.</p> <p>Helps to improve the issuer’s positioning and bring it up to date for the demands of the digital era</p> <p>Complements any existing program.</p> <p>Supplements and reinforces its current rewards offering.</p> <p>Reenergizes a product.</p> <p>Integrates different brands of products.</p>
                </div>
                <div class="gennius__column gennius__column--novae">
                    <img class="gennius__img" src="./assets/img/gennius/visa/novae-image.webp" alt="gennius">
                </div>
                <div class="gennius__column gennius__column--novae">
                    <span>How</span>
                    <p>Turnkey solution, so limited dedicated tech resources are needed.</p> <p>Customized to your brand.</p> <p>Offers a lower rewards cost.</p> <p>Provides specialized support during the implementation process and beyond.</p>
                </div>
            </div>
        </section>
        <section id="item-50-section" class="gennius--intro gennius--supports gennius--container white">
            <div class="container gennius">
                <div class="gennius__center gennius__center--supports">
                    <h4 class="subtittle">My Rewards supports businesses every step of the way</h4>
                </div>
                <div class="gennius__bloque gennius__bloque--supports gennius__bloque--top">
                    <div class="gennius__left gennius__left--supports">
                        <img class="gennius__img" src="./assets/img/gennius/visa/supports-image.webp" alt="gennius">
                    </div>
                    <div id="item-50" class="gennius__right gennius__right--supports">
                        <span class="especial">We bring added value to partners and a superior user experience to their customers.</span>
                        <div class="item">
                            <span>Lifecycle Management <p>End-to-End Marketing Support</p></span>
                            <ul>
                                <li>White-label or customized experience</li>
                                <li>Promotes early activation, and spend stimulation</li>
                                <li>E-mail marketing / push notifications / SMS / WhatsApp / Facebook / Instagram / iMessage / Web banners/ Landing Page</li>
                                <li>Predictive AI/ML model maximizes conversion rates</li>
                            </ul>
                        </div>
                        <div class="item">
                            <p class="tittle"><strong>Digital Engagement Plan</strong></p>
                            <p>End-to-end marketing for cardholder onboarding, registration, first redemption, and repeat use.</p>
                        <p><strong>My Rewards</strong> will lead all marketing efforts through the development and execution of a plug and play packaged solutions to drive the issuer’s portfolio lifecycle.</p>
                    <p>From awareness and activation to ongoing redemption and spend.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-51-section" class="gennius--universal gennius--bo white gennius--container">
            <div class="container gennius">
                <div class="gennius__center">
                    <h4 id="item-51">Fast track <strong class="italic">back-office</strong></h4>
                </div>
            </div>
            <div class="gennius__bloque gennius__bloque--bo">
                <div class="container gennius container-absolute">
                    <div class="gennius__left gennius__left--bo">
                        <div class="item">
                            <p>The new <strong>My Rewards portal</strong> offers a series of functionalities and tools designed to facilitate and streamline all processes carried out by financial institutions.</p>
                            <p>Plus, it features an array of options to customize the mobile app and web platform’s look and feel, through a selection of colors and logos.
                            </p>
                            <span>Effortless implementation extends to a issuer’s daily logistics of managing cardholders’ accounts.
                            </span>
                            <p>This is done by creating values) to award points, update point balances, and add new cardholders, among others. All of this is accomplished through the platform’s back office, so no technology or infrastructure development is required on the issuer’s part.</p>
                        </div>
                    </div>
                </div>
                <img class="gennius__img gennius__img--bo" src="./assets/img/gennius/visa/bo-image.webp" alt="gennius">
            </div>
        </section>
        <section id="item-52-section" class="gennius--universal gennius--easy white gennius--container">
            <div class="container gennius">
                <div class="gennius__center">
                    <h4 id="item-52">Easy Implementation</h4>
                </div>
            </div>
            <div class="gennius__bloque gennius__bloque--easy">
                <img class="gennius__img gennius__img--easy" src="./assets/img/gennius/visa/easy-image.webp" alt="gennius">
                <div class="container gennius container-absolute">
                    <div class="gennius__right gennius__right--easy">
                        <div class="item">
                            <p>Plug & Play tool of <strong>My Rewards</strong> is the best bank's ally. It allows an easy and fast implementation, with no need of development or infrastructure. Plus, it powers up the platform's digital features to bring a superior experience without friction.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-53-section" class="gennius--business white">
            <div class="container gennius">
                <div class="gennius__center gennius__center--business">
                    <span id="item-53">Implementation takes 6-10 business days and includes:</span>
                </div>
                <div class="bl-includes">
                    <img class="gennius__img gennius__img--business" src="./assets/img/gennius/visa/diagram.png" alt="gennius">
                    <div class="bloque">
                        <div class="item">
                            <p>Kick-Off –Program overview  with a dedicated point person / team</p>
                        </div>
                        <div class="item">
                            <p>Platform training for Bank’s Project Manager</p>
                        </div>
                        <div class="item">
                            <p>Access to stage environment to become familiar with program tools, tests, file uploading, reports, etc.</p>
                        </div>
                        <div class="item">
                            <p>Production phase - bank set up in program, app customization, uploading of  cardholders’ information files</p>
                        </div>
                        <div class="item">
                            <p>Cardholders receive a welcome email with instructions to enroll in program</p>
                        </div>
                        <div class="item">
                            <p>Program goes  live  / rollout</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-54-section" class="gennius--table white">
            <div class="container gennius">
                <div class="gennius__center gennius__center--business">
                    <h4 id="item-54">My Rewards vs. Loyalty Programs</h4>
                </div>
                <div class="table">
                    <div class="block-row block-row--tittle">
                        <div class="gennius__column">
                        </div>
                        <div class="gennius__column">
                            <span>My Rewards</span>
                        </div>
                        <div class="gennius__column">
                            <span>Other Programs</span>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-1.png" alt="gennius">
                            <span>Redemption <br>inventory</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>Millions of redemption options</p>
                        </div>
                        <div class="gennius__column">
                            <p>Most reward programs are limited to one airline or one travel agency</p>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-2.png" alt="gennius">
                            <span>Rates /<br> Prices</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>Up to 50% off on hotels and Best-Price Guarantee*, plus travel benefits included in fare</p>
                        </div>
                        <div class="gennius__column">
                            <p>Rewards are usually more expensive than their market price</p>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-3.png" alt="gennius">
                            <span>Redemption <br>
                                experience</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>A digital user-friendly platform to redeem points unassisted</p>
                        </div>
                        <div class="gennius__column">
                            <p>Redemptions in most programs are not easy and require cardholders to call a dedicated unit</p>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-4.png" alt="gennius">
                            <span>Customer <br>
                                service</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>Highly-trained agents and intuitive bots provide 24/7 support in English and Spanish</p>
                        </div>
                        <div class="gennius__column">
                            <p>Call centers usually work during business hours only</p>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-5.png" alt="gennius">
                            <span>Payment<br> options</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>Highly-trained agents and intuitive bots provide 24/7 support in English and Spanish</p>
                        </div>
                        <div class="gennius__column">
                            <p>Most programs require to achieve certain amount of points. Some offer to buy points</p>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-6.png" alt="gennius">
                            <span>Redemption<br>channels</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>Ability to switch between mobile and desktop devices to manage points and redeem</p>
                        </div>
                        <div class="gennius__column">
                            <p>Usually limited to webpage or phone customer service </p>
                        </div>
                    </div>
                    <div class="block-row">
                        <div class="gennius__column">
                            <img class="gennius__img gennius__img--table" src="./assets/img/gennius/visa/table-icon-7.png" alt="gennius">
                            <span>Security<br> data</span>
                        </div>
                        <div class="gennius__column gennius__column--blue">
                            <span></span>
                            <p>Ability to make secure payments and store personal data with top-level encryption</p>
                        </div>
                        <div class="gennius__column">
                            <p>Most programs do not store payment information because they can’t ensure data security</p>
                        </div>
                    </div>
                </div>
                <p class="special">*Price displayed include the hotel promotional discount, extra discount not included. This promotion is valid from “Start Date“ to “End Date”. Offers are subject to limited availability and may be discontinued without notice. My Rewards' booking terms and conditions apply.
                </p>
            </div>
        </section>
        <section id="item-55-section" class="gennius--key card-five home-five white">
            <div class="gennius__center gennius__center--supports">
                <h4 id="item-55" class="subtittle">KPIs y Key Metrics</h4>
                <span>The first month of MR 2.0 results show a great increase in redemptions and positive indicators.</span>
            </div>
            <owl-carousel [options]="SlideOptions" [carouselClasses]="['owl-theme', 'sliding', 'timeout', 'speed']">
                <section class="item item-1">
                    <div class="container">
                        <div class="bloque-key">
                            <div class="item">
                                <span class="special-text">Factor vs 1.0</span>
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-1.png" alt="gennius">
                                <p>Registered<br> users <strong>(1st month)</strong></p>
                                <span>9x</span>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-4.png" alt="gennius">
                                <p>Redemptions</p>
                                <span>6x</span>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-2.png" alt="gennius">
                                <p>Unique<br> users</p>
                                <span>5x</span>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-5.png" alt="gennius">
                                <p>Average<br> purchase ($)</p>
                                <span>6x</span>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-3.png" alt="gennius">
                                <p>Txn per<br> user</p>
                                <span>3x</span>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-6.png" alt="gennius">
                                <p>Interactions </p>
                                <span>3x</span>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="item item-2">
                    <div class="container">
                        <div class="bloque-key">
                            <div class="item special">
                                <span>Universal redemption + T&E</span>
                                <p>E-commerce (Amazon, PayPal AliBaba, Apple, Google), Supermarkets, Restaurants, Telco, Retail, Transportation, Education, Services Stations, Services/Taxes, Donations
                                </p>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-8.png" alt="gennius">
                                <p>47% points redeemed in the 1st month</p>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-3.png" alt="gennius">
                                <p>78% increase in redemption users</p>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-3.png" alt="gennius">
                                <p>23% users redeem more than 80% of their points</p>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-7.png" alt="gennius">
                                <p>100%<br> performance</p>
                            </div>
                            <div class="item">
                                <img class="gennius__img gennius__img--key" src="./assets/img/gennius/visa/key-icon-4.png" alt="gennius">
                                <p>25K emails sent
                                    WhatsApp: 5.8k conversations</p>
                            </div>
                        </div>
                    </div>
                </section>
            </owl-carousel>
        </section>
        <section id="item-56-section" class="gennius--supports gennius--platform white">
            <div class="container gennius">
                <div class="gennius__center gennius__center--platform">
                    <h4 id="item-56" class="subtittle">My Rewards - platform structure options:</h4>
                    <span>Visa Members will have the option of selecting between a Multi-tenant structure and Single-tenant structure to satisfy their business needs:</span>
                </div>
                <div class="gennius__bloque gennius__bloque--supports">
                    <div class="gennius__left gennius__left--platform">
                        <div class="item">
                            <img class="gennius__img gennius__img--platform" src="./assets/img/gennius/visa/icon-multi.png" alt="gennius">
                            <div class="text text-line">
                                <span>Multi-tenant
                                </span>
                                <p>Consists of a <strong>My Rewards</strong> white-label solution available to all issuer users through the same URL and/or Application (APP) available in the Apple Store and Google Play. Once users login to the platform, the bank logo will be reflected together with limited color customization.</p>
                            </div>
                        </div>
                        <div class="item">
                            <img class="gennius__img gennius__img--platform" src="./assets/img/gennius/visa/icon-single.png" alt="gennius">
                            <div class="text">
                            <span>Single-tenant
                            </span>
                            <p>In this option, each <strong>issuer</strong> will have an exclusive URL and APP (available in Stores) for users to access/download.  This option provides greater brand identity for banks through the web / app custom design</p>
                        </div>
                        </div>
                    </div>
                    <div class="gennius__right gennius__right--platform">
                        <img class="gennius__img" src="./assets/img/gennius/visa/easy-image.webp" alt="gennius">
                    </div>
                </div>
            </div>
        </section>
        <section id="item-57-section" class="gennius--container gennius--description white">
            <div class="container">
                <div class="table table-tittle">
                    <div id="item-57" class="left">
                        <img class="gennius__img gennius__img--platform" src="./assets/img/gennius/visa/logo-rewards.png" alt="gennius">
                    </div>
                    <div class="right">
                        <div class="item">
                            <div class="column column-text">
                                <span>Description</span>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--platform" src="./assets/img/gennius/visa/icon-multi.png" alt="gennius">
                                <span>Multi-Tenant</span>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--platform single" src="./assets/img/gennius/visa/icon-single.png" alt="gennius">
                                <span>Single-Tenant</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table">
                    <div class="left">
                        <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/description-image.webp" alt="gennius">
                    </div>
                    <div class="right">
                        <div class="item">
                            <div class="column column-text">
                                <p>Personalized App at stores</p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>My Rewards Web</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized web</p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized store icon & description</p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized App & App name</p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Platform Communications</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized communications (Life Cycle Management)
                                </p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized promotional materials
                                </p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Bank Manuals
                                </p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>User Guide
                                </p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customer support 7/24
                                </p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Interactive channels
                                </p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized Bot
                                </p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Customized messages
                                </p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Support</p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Back office
                                </p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Reporting</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                        <div class="item">
                            <div class="column column-text">
                                <p>Tailor made reports
                                </p>
                            </div>
                            <div class="column column-multi">
                                <p>-</p>
                            </div>
                            <div class="column column-multi">
                                <img class="gennius__img gennius__img--description" src="./assets/img/gennius/visa/icon-check.png" alt="gennius">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-58-section" class="gennius--intro gennius--supports gennius--reserved white">
            <div class="container gennius">
                <div class="gennius__center gennius__center--supports">
                    <h4 id="item-58" class="subtittle">Let’s get started.<br>
                        It's time to bring them their<br> freedom to redeem.</h4>
                    <a class="btn-gennius" href="https://mr2.sale/" target="_blank">Partner with us</a>
                </div>
                <p>Third Party Logos or IP: All brand names, logos and/or trademarks are the property of their respective owners, are used for identification purposes only, and do not necessarily imply product endorsement or affiliation with Visa
                </p>
                <div class="reserved">
                    <p>©2023 Visa. All rights reserved.</p>
                    <img class="gennius__img gennius__img--reserved" src="./assets/img/gennius/visa/logo-visa.png" alt="gennius">
                </div>
            </div>
        </section>
        <app-footer></app-footer>
        <section class="section clearBoth"></section>
    </section>
</section>
